export default "__VITE_ASSET__CiMbuD1V__"